<template>
  <div v-if="$page.props.auth.user.role == 'mtd' || items.length > 0">
    <div class="cart-title py-2 px-3 bg-primary text-white d-flex justify-content-between">
      <p class="font-weight-bold mb-0">
        {{ items.length }} Item{{ items.length > 1 ? 's' : '' }} in Cart
      </p>
      <button type="button" class="close text-muted" aria-label="Close" style="text-shadow: none;">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="cart-item-container">
      <div class="cart-item row w-100 m-0 py-2 px-3 border-bottom" v-for="item in items" :key="item">
        <div class="mb-1 font-weight-bold">
          <p class="cart-item-product-name mb-0"><span class="text-secondary">({{item.product.sku}}) </span>{{ item.product.name }}</p>
        </div>
        <div class="d-flex justify-content-between w-100">
          <p class="mb-0 text-size-small text-secondary">{{ formatDollars((item.product.productPrice.price)) }} x {{ item.qty }}:</p>
          <h6 class="mb-0 text-success text-right">{{ formatDollars((item.product.productPrice.price) * item.qty) }}</h6>
        </div>
      </div>
    </div>
    <div class="bg-light py-2 px-3">
      <div class="text-right">
        <p class="font-weight-bold mb-1">Total</p>
        <h5 class="text-success">{{ formatDollars(total) }}</h5>
      </div>
      <jet-button icon="fas fa-shopping-cart" class="w-100 mt-3" :goesTo="route(routes.view)">View Cart</jet-button>

      <jet-button v-if="($page.props.auth.user.role == 'shop' || isWholesale) && items.length > 0" icon="fas fa-credit-card" class="w-100 mt-2" @click="$inertia.visit(route(routes.checkout))">Checkout</jet-button>
    </div>
  </div>
  <div v-else class="p-3">
    <p class="m-0">No items in cart</p>
  </div>
</template>

<script>
  export default {
    props: {
      routes: Object,
      items: Array,
      total: Number,
      isWholesale: Boolean
    }
  }
</script>
